import { Button, Form, Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useRejectScheduleMutation } from 'app/services/edpApiV1/vacationsSchedule';
import { useAppSelector } from 'app/store';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import React, { SetStateAction, useState } from 'react';
import { getErrorData } from 'shared/helpers/utils';
import { useNotifications } from 'shared/hooks/use-notifications';

type TProps = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<SetStateAction<boolean>>;
  requestId: number | string | undefined;
  employeeId: number | string | undefined;
};

const ModalReason = ({ isModalOpen, setIsModalOpen, requestId, employeeId }: TProps) => {
  const [currentText, setCurrentText] = useState<string>();
  const [rejectTrigger, result] = useRejectScheduleMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
  });
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const { isSuccess, isError, error, reset } = result;

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // если отсутствует текст, игнорирую пробелы и переносы строки клавищей "ENTER"
    if (!currentText) {
      setCurrentText(e.target.value.replace(/^\s+/g, ''));
    } else {
      setCurrentText(e.target.value);
    }
  };

  const handleOk = () => {
    if (requestId && employeeId) {
      rejectTrigger({
        employeeId: Number(employeeId),
        requestId: Number(requestId),
        comment: currentText,
      });
    }
    setIsModalOpen(false);
    setCurrentText(undefined);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setCurrentText(undefined);
  };

  useNotifications(isSuccess, isError, 'Заявка отклонена', error?.message, reset);

  return (
    <Modal
      title="Напишите причину отказа"
      visible={isModalOpen}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Отмена
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} disabled={!currentText}>
          Отправить
        </Button>,
      ]}
    >
      <Form.Item rules={[{ required: true, message: 'Пожалуйста, введите текст' }]}>
        <TextArea
          showCount
          maxLength={300}
          minLength={1}
          onChange={onChange}
          placeholder="Причина отказа"
          rows={8}
          value={currentText}
          required
        />
      </Form.Item>
    </Modal>
  );
};

export default ModalReason;
